import { render } from "./FaceRecognitionDirective.vue?vue&type=template&id=7fc6f2da&scoped=true"
import script from "./FaceRecognitionDirective.vue?vue&type=script&lang=js"
export * from "./FaceRecognitionDirective.vue?vue&type=script&lang=js"

import "./FaceRecognitionDirective.vue?vue&type=style&index=0&id=7fc6f2da&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fc6f2da"]])

export default __exports__